import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=66498664&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&lang=ts"
export * from "./ClientEdit.vue?vue&type=script&lang=ts"
import style0 from "./ClientEdit.vue?vue&type=style&index=0&id=66498664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66498664",
  null
  
)

export default component.exports